export const Empty = {
  DEFAULT: {
    TEXT: "На жаль, тут порожньо, потрібно спочатку додати, щоб почати роботу 💪",
  },
};
